import React from "react";
import {PackageVariant} from "mdi-material-ui";

export default function PickUp(props) {
    return (
        <PackageVariant className={props.className} />
    );
};